import { Component } from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {Location} from "@angular/common";
import {ApiServiceService} from "../../../Services/api-service.service";
import {AuthService} from "../../../Services/auth.service";
import alertify from "alertifyjs";
import { Constant } from 'src/app/Shared/Constant';
@Component({
  selector: 'app-public-asin-search',
  templateUrl: './public-asin-search.component.html',
  styleUrls: ['./public-asin-search.component.css']
})
export class PublicAsinSearchComponent {
  isEmpty: boolean = false;
  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  details: any;
  isLoading: boolean = false;
  isSearching: any;
  count: number = 0;
  pageSize: number = 5;
  searchForm: any = FormGroup;
  showSearch: boolean = false;
  selectedOutput: any;
  countDetails: any;
  searchInstruction: boolean;
  showFilters = false;
  minDate: any;



  constructor(
      private location: Location,
      private fb: FormBuilder,
      private apiService: ApiServiceService,
      private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      email: [""],
      phone: [""],
    });

    this.selectedOutput = "all";

    this.searchInstruction = true;
  }
  toggleSearch() {
    this.showSearch = !this.showSearch;
  }
  resetForm() {
    this.searchForm = this.fb.group({
      email: [""],
      phone: [""]
    });
  }

  search() {
    this.searchInstruction = false;

    this.details = {};

    var formData: any = new FormData();
    this.isEmpty = false;
    this.isSearching = true;
    this.isLoading = true;

    this.num = this.page * 5;

    let req = {
      phoneNumber: this.searchForm.get("phone")?.value.trim() || "", 

      email: this.searchForm.get("email")?.value.trim() || ""
    } 
    const url = "/auth/utility/search-asin";

    this.apiService.loginPost_(url, req).subscribe({
      next: (res: any) => {
        if (res == null) {
          alertify.set('notifier', 'position', 'top-center');
          alertify.error("User not found", 5);
          this.isLoading = false;
          this.isSearching = false;
        } else {
          this.details = res;
          this.isLoading = false;
          this.isSearching = false;
          this.toggleFilter()
        }
      },
      error: (err: any) => {
        alertify.set('notifier', 'position', 'top-center');
        alertify.error(Constant.ERROR_OCCURED, 5);
        this.isEmpty = true;
          this.isSearching = false;
      }
    });

  }


  goBack() {
    this.location.back();
  }

  toggleFilter(): void {
    this.showFilters = !this.showFilters;
  }

  now(): Date {
    return new Date();
  }

  get minDateValue(): any {
    return this.minDate;
  }
}
